// form specifc
window.formMagic = function(){
	window.updateDateTime();
	
	// fancy file replace | on click "activate" hidden file field
	$("body").on('click','.frBtn',function(){
		$(this).parent().find(".fileRemove").click();
	});
	// on change show selected filename
	$("body").on('change','.fileRemove',function(e){
		$(this).parent().find(".fileView").val(e.target.files[0].name);
	});


	$(".typeSel").each(function(e) {
		selectGroup($(this));
	});
}


// return  table action description to default "Action"
$("body").on('change', '.typeSel', function(){
	selectGroup($(this));
});
function selectGroup(thisEl){
	var val = thisEl.val();
	var tscGroup = thisEl.attr("tsc-group");

	if(val == "A"){
		$('.typeSelBox.' + tscGroup).show();
	}else{
		$('.typeSelBox.' + tscGroup).hide();
		$('.typeSelBox.' + tscGroup + '[rel="' + val + '"]').show();
	}
}
